var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main_container" }, [
    _c("div", { staticClass: "content_mc_wrp" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("div", { staticClass: "header__nav" }, [
            _vm.navTabs
              ? _c(
                  "div",
                  { staticClass: "tabs_container" },
                  _vm._l(_vm.navTabs, function(tab, index) {
                    return _c(
                      "NavTab",
                      _vm._b(
                        {
                          key: index,
                          attrs: {
                            active:
                              tab.key == _vm.$route.name ||
                              (_vm.$route.params &&
                                _vm.$route.params.asset &&
                                _vm.$route.params.asset == tab.key)
                          }
                        },
                        "NavTab",
                        tab,
                        false
                      )
                    )
                  }),
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("router-view")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca4d0338", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca4d0338","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProfileWrapper.vue
// module id = null
// module chunks = 